import React, { useState } from "react";
import { User, Phone, Mail, MapPin } from "lucide-react";

const PatientOutDetails = ({ patient }) => {
  const [imageError, setImageError] = useState(false);

  // Generate gradient background based on name
  const generateGradient = (name) => {
    if (!name) return "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)";
    const colors = [
      ["#10b981", "#059669"],
      ["#3b82f6", "#1d4ed8"],
      ["#8b5cf6", "#7c3aed"],
      ["#f59e0b", "#d97706"],
      ["#ef4444", "#dc2626"],
      ["#06b6d4", "#0891b2"],
    ];

    const hash = name.split("").reduce((a, b) => a + b.charCodeAt(0), 0);
    const colorPair = colors[hash % colors.length];
    return `linear-gradient(135deg, ${colorPair[0]}, ${colorPair[1]})`;
  };

  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  return (
    <div
      style={{
        padding: "20px",
        background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "16px",
          marginBottom: "16px",
        }}
      >
        {/* Avatar */}
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "16px",
            overflow: "hidden",
            border: "3px solid var(--color-secondary)",
            boxShadow: "0 4px 12px rgba(16, 185, 129, 0.2)",
          }}
        >
            <div
              style={{
                width: "100%",
                height: "100%",
                background: generateGradient(patient?.patientInfo?.patientName),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "28px",
                fontWeight: "700",
                color: "white",
                textShadow: "0 2px 4px rgba(0,0,0,0.3)",
              }}
            >
              {getInitials(patient?.patientInfo?.patientName)}
            </div>
        </div>

        {/* Patient Info */}
        <div style={{ flex: 1 }}>
          <h2
            style={{
              margin: "0 0 4px 0",
              fontSize: "22px",
              fontWeight: "700",
              color: "var(--color-dark-deep)",
              lineHeight: "1.2",
            }}
          >
            {patient?.patientInfo?.patientName}
          </h2>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "8px",
              color: "var(--color-dark-light)",
              fontSize: "14px",
            }}
          >
            <User size={16} />
            <span>{patient?.patientInfo?.patientUserUniqueID}</span>
            <span style={{ margin: "0 4px" }}>•</span>
            <span>
              {patient?.patientInfo?.age}Y, {patient?.patientInfo?.gender || "N/A"}
            </span>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              color: "var(--color-dark-light)",
              fontSize: "13px",
              marginBottom: "4px",
            }}
          >
            <Phone size={14} />
            <span>{patient?.patientInfo?.contactNumber || "N/A"}</span>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              color: "var(--color-dark-light)",
              fontSize: "13px",
            }}
          >
            <Mail size={14} />
            <span>{patient?.patientInfo?.emailAddress || "N/A"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientOutDetails;
